var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEffort24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "m9.32 12.15-.86-.86c-.4-.4-.62-1-.22-1.4l1.8-1.8c.4-.42 1.15-.34 1.56.07l4.31 4.32c.42.4.42 1.07 0 1.48l-1.78 1.8c-.41.41-1.01.19-1.42-.22l-.86-.86m-2.53-2.53 2.53 2.53m-2.53-2.53L4.77 16.7m7.08-2.02L7.3 19.23m0 0c1.39-1.33 2.9.82 2.92 2.02.01.41.36.75.78.75h2c.87 0 .78-.96.8-1.56.01-1.1 2-1.78 2.8-1.02.43.42 1.15.97 1.76.36l1.42-1.42c.61-.61.06-1.33-.36-1.76-.75-.8-.08-2.78 1.02-2.8.6-.02 1.56.07 1.56-.8v-2c0-.87-.96-.78-1.56-.8-1.1-.01-1.78-2-1.02-2.8.42-.43.97-1.15.36-1.76l-1.42-1.42c-.61-.61-1.33-.06-1.76.36-.83.79-2.79.07-2.8-1.02-.02-.6.07-1.56-.8-1.56h-2c-.87 0-.78.96-.8 1.56-.02 1.15-2.01 1.77-2.8 1.02-.43-.42-1.15-.97-1.76-.36L4.22 5.64c-.61.61-.06 1.33.36 1.76.79.83.07 2.79-1.02 2.8-.6.02-1.56-.07-1.56.8v2c0 .42.34.77.75.78 1.21.02 3.23 1.65 2.02 2.92m2.53 2.53c-1.1 1.1-1.1 1.1-1.66.55l-1.42-1.42c-.56-.56-.56-.56.55-1.66",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffort24);
export default __webpack_public_path__ + "static/media/effort_24.68cab8e22189ddb9eaaf3159819e09b7.svg";
export { ForwardRef as ReactComponent };